import { render, staticRenderFns } from "./ion-upload.vue?vue&type=template&id=5f122c1c"
import script from "./ion-upload.vue?vue&type=script&lang=js"
export * from "./ion-upload.vue?vue&type=script&lang=js"
import style0 from "./ion-upload.vue?vue&type=style&index=0&id=5f122c1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports